import React, { useEffect, useRef, useState } from "react";
import { Eye } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

// Boost view counter: counts up smoothly when the value grows and flashes a "+N" bubble.
export const LiveBoostViews = ({ value = 0 }) => {
  const { t } = useLang();
  const [shown, setShown] = useState(value);
  const [delta, setDelta] = useState(0);
  const prev = useRef(value);

  useEffect(() => {
    const from = prev.current;
    prev.current = value;
    if (value <= from) { setShown(value); return; }
    setDelta(value - from);
    const start = performance.now();
    let raf;
    const step = (now) => {
      const p = Math.min(1, (now - start) / 900);
      setShown(Math.round(from + (value - from) * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    const hide = setTimeout(() => setDelta(0), 1800);
    return () => { cancelAnimationFrame(raf); clearTimeout(hide); };
  }, [value]);

  return (
    <span className="relative inline-flex items-center gap-1 font-semibold text-findo-navy" data-testid="live-boost-views">
      <span className="live-dot" aria-hidden="true" />
      <Eye size={13} />
      <span className="tabular-nums" data-testid="live-boost-views-count">{shown}</span>
      <span className="text-[10px] uppercase tracking-wide text-findo-red font-bold">{t("mc2.live")}</span>
      {delta > 0 && (
        <span key={value} className="live-delta" data-testid="live-boost-views-delta">+{delta}</span>
      )}
    </span>
  );
};
